import React, { useEffect, useState } from 'react';
import {
    Checkbox,
    FormControlLabel,
    Typography,
    FormGroup,
    DialogContent,
    DialogActions
} from '@mui/material';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';

const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const WeekendSettingsModal = ({ onClose, selectedDays = [], handleWeekendChange, handleSaveWeekend }) => {
    const [localSelectedDays, setLocalSelectedDays] = useState(selectedDays);

    useEffect(() => {
        setLocalSelectedDays(selectedDays);
    }, [selectedDays]);

    const handleCheckboxChange = (day) => {
        const updatedDays = localSelectedDays.includes(day)
            ? localSelectedDays.filter(d => d !== day)
            : [...localSelectedDays, day];
        handleWeekendChange(updatedDays);
    };


    return (
        <>
            <DialogContent dividers>
                <Typography variant="subtitle1" gutterBottom>
                    Select Weekend Days:
                </Typography>
                <FormGroup row>
                    {daysOfWeek.map((day) => (
                        <FormControlLabel
                            key={day}
                            control={
                                <Checkbox
                                    checked={localSelectedDays.includes(day)}
                                    onChange={() => handleCheckboxChange(day)}
                                />
                            }
                            label={day}
                        />
                    ))}
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <ActionButton onClick={onClose} label="Cancel" btnType="outlined" />
                <ActionButton onClick={handleSaveWeekend} label="Save" btnType="primary" />
            </DialogActions>
        </>
    );
};

export default WeekendSettingsModal;
